import {Component, OnDestroy, OnInit, ViewChild, Inject, ElementRef} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from "@angular/router";
import {GridApi, IDatasource, IGetRowsParams, SortModelItem} from "ag-grid-community";
import {TooltipFieldComponent} from "../../plan/tooltip-field/tooltip-field.component";
import {DateRangeFieldComponent} from "../../plan/date-range-field/date-range-field.component";
import {ModifiedDateFieldComponent} from "../../plan/modified-date-field/modified-date-field.component";

import {MessageService} from "primeng/api";
import {Actions, ofType} from "@ngrx/effects";
import {TranslateService} from "@ngx-translate/core";
import {AuthenticationService} from "../../../authentication.service";
import {ImportedForecastsLoadingOverlayComponent} from "../imported-forecasts-loading-overlay/imported-forecasts-loading-overlay.component";
import {InputTextComponent} from "../../../components/input-text/input-text.component";
import { Store, select } from "@ngrx/store";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { ImportedForecastsDialogComponent } from '../imported-forecasts-dialog/imported-forecasts-dialog.component';
import { EspPermissions } from '../../../common/enums';
import {
  AppActionTypes,
  GetImportForecastsList,
  ImportForecastsListReceived,
  ImportForecastsListRetrieveFailed,
  DeleteForecastsFailed,
  DeleteForecastsSuccess,
  DeleteImportedForecasts
} from "../../../store/actions";
import {Subscription} from "rxjs";
import { ImportedForecastsViewLogComponent } from '../imported-forecasts-view-log/imported-forecasts-view-log.component';
import { EspTableHeaderComponent } from 'src/app/components/esp-table-header/esp-table-header.component';
import { EspNoRowsOverlayComponent } from 'src/app/components/no-rows-overlay/no-rows-overlay.component';
import { Features } from 'src/app/models/plan';
import { ImportedForecastStatusEnum } from '../common/imported-forecast-status-enum';
import { GridItemActionComponent } from 'src/app/components/grid-item-action/grid-item-action.component';
import { tabSuppressKeyboardEventForFocusableChildren } from 'src/app/common/utils/ag-grid-a11y';
import { suppressHomeEndKeyboardEvent } from 'src/app/common/utils/ag-grid-a11y';
import { suppressGridTabToInteractiveControls } from 'src/app/common/utils/ag-grid-a11y';
import { combineGridKeyboardSuppressors } from 'src/app/common/utils/ag-grid-a11y';
import { fixGridNonActiveTabOrder } from 'src/app/common/utils/ag-grid-a11y';
import { makeGridScrollRegionFocusable } from 'src/app/common/utils/ag-grid-a11y';
import { redirectSelectionCheckboxFocusToCell } from 'src/app/common/utils/ag-grid-a11y';
import { setGridActivationDescription } from 'src/app/common/utils/ag-grid-a11y';
import { setGridAccessibleName } from 'src/app/common/utils/ag-grid-a11y';
import { GRID_ARIA_LOCALE_TEXT } from 'src/app/common/utils/ag-grid-a11y';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'wfm-esp-imported-forecasts-list',
  templateUrl: './imported-forecasts-list-page.component.html',
  styleUrls: ['./imported-forecasts-list-page.component.scss'],
  providers: [MessageService]
})
export class ImportedForecastsListPageComponent implements OnInit, OnDestroy {

  protected subscriptionList: Array<Subscription> = [];
  public gridApi: GridApi = null;
  public gridColumnApi: any;
  public rowClassRules;
  public rowBuffer = 10;
  public rowModelType = "infinite";
  public infiniteInitialRowCount = 0;
  public cacheBlockSize = 50;
  public frameworkComponents: any;
  public loadingOverlayComponent = "ImportedForecastsLoadingOverlayComponent";
  public noRowsOverlayComponent = "noImportedForecastsOverlay";
  public currentGetRowParam: IGetRowsParams;
  public datasource: IDatasource;
  public context;
  public readonly gridAriaLocaleText = GRID_ARIA_LOCALE_TEXT;
  public rowData = [];
  public espPermission:EspPermissions = EspPermissions.VIEW;
  public locale : string = environment.defaultLocale;
  protected isRowSelectable:any;
  private sortBy: any;
  private sortOrder: any;
  public filterText: string;
  public searchAnnouncement = "";
  public  _isLoading = false;
  private checkboxAriaLabelsScheduled = false;
  private selectionCheckboxFocusCleanup: (() => void) | null = null;
  private scrollRegionSyncCleanup: (() => void) | null = null;

  public noRowsOverlayComponentParams:any;

  private readonly DEFAULT_SORT_MODEL:SortModelItem[] = [{ colId: "forecastName", sort: 'asc' }];

  @ViewChild("searchTextBox") searchBoxEl: InputTextComponent;
  @ViewChild("forecastDeletePopover") forecastDeletePopover: NgbPopover;

  constructor(private store: Store<any>, private modalService: NgbModal,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private messageService: MessageService,
              private action$: Actions,
              private translate: TranslateService,
              private authService: AuthenticationService,
              private elementRef: ElementRef,
              @Inject(DOCUMENT) private document: Document) {
    this.context = {
      componentParent: this,
      isLoading: this.isLoading.bind(this),
    };
    this.rowClassRules = {
      "row-disabled": (params) => this.disableRows(params)
    };

    this.isRowSelectable = function(rowNode) {
      return (rowNode.data && rowNode.data.importStatus && (rowNode.data.importStatus.toUpperCase() === 'PROCESSED'
      || rowNode.data.importStatus.toUpperCase() === "FAILED") ) ? true : false;
    };
     this.noRowsOverlayComponentParams = {
      getOverlayMsg: () => {
        let msgKey = this.filterText ? "search.no.results.msg" : "imported.forecasts.no.rows";
        return this.translate.instant(msgKey)
      }
    }
  }

  defaultColDef={
    sortable:true,
    // a11y (ESP-18522): the grid contains interactive controls (row checkbox,
    // Forecast Name link, Delete icon), so Tab must visit each of those controls
    // in order (all sortable headers → row-select cell → Forecast Name →
    // optional row actions → Delete) while read-only text cells are reachable
    // only with the Arrow keys. Home/End stay row/grid-scoped.
    suppressKeyboardEvent: combineGridKeyboardSuppressors(suppressGridTabToInteractiveControls, suppressHomeEndKeyboardEvent)
  }
  ngOnInit() {
    this.frameworkComponents = {
      GridItemActionComponent: GridItemActionComponent,
      TooltipField: TooltipFieldComponent,
      DateRangeField: DateRangeFieldComponent,
      ModifiedDateField: ModifiedDateFieldComponent,
      noImportedForecastsOverlay: EspNoRowsOverlayComponent,
      ImportedForecastsLoadingOverlayComponent: ImportedForecastsLoadingOverlayComponent,
      agColumnHeader: EspTableHeaderComponent
    };
    let state = this.store.select("state");
    state.subscribe((data) => {
      if (data.user){
        this.espPermission = data.user.espPermission;
      }
      if (data.locale) {
        this.locale = data.locale;
      }
    });

    this.addToSubscriptionList(this.activatedRoute.queryParams
      .subscribe(params => {
        this.sortBy = params['sortBy'] || null;
        this.sortOrder = params['sortOrder'] || null;
        this.setColumnDefsSort(this.sortBy, this.sortOrder);
      }));
    this.columnDefs.forEach(a => a.headerComponentParams =  {
      headerPrefix: "imported.forecasts.header.",
      // Keep column-name tooltips available on mouse hover, but do not open
      // them merely because keyboard focus moved onto an Import Forecast header.
      showTooltipOnFocus: false,
      // Select remains skipped, while the visible Actions columnheader is a
      // named stop between Import Status and the first row control.
      includeInHeaderTabOrder: a.colId === "actions",
      focusFirstBodyControl: () => this.focusFirstGridBodyControl()
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.api;
    this.datasource = { getRows: (params: IGetRowsParams) => this.getImportForecastsList.call(this, params) };
    this.gridApi.setDatasource(this.datasource);
    this.initHandlers();
    this.setColumnVisibility();
    this.gridApi.sizeColumnsToFit();
    fixGridNonActiveTabOrder(this.elementRef.nativeElement);
    // Retain and dispose the cleanup so the header/body scroll listeners can't
    // accumulate if onGridReady fires again for the same grid.
    this.scrollRegionSyncCleanup?.();
    this.scrollRegionSyncCleanup = makeGridScrollRegionFocusable(this.elementRef.nativeElement);
    // a11y (ESP-18552): keep the row-select CELL as the single Tab stop and off
    // the checkbox <input> (AG Grid otherwise drives focus onto the checkbox).
    this.selectionCheckboxFocusCleanup?.();
    this.selectionCheckboxFocusCleanup = redirectSelectionCheckboxFocusToCell(this.elementRef.nativeElement);
    // a11y (ESP-18522): announce the row-level open action once on grid entry.
    setGridActivationDescription(this.elementRef.nativeElement, "forecastGridActivationHelp");
    // a11y (ESP-18464): give the grid a caption so JAWS announces "Import
    // Forecasts" on grid entry and on "T" table navigation.
    setGridAccessibleName(this.elementRef.nativeElement, this.translate.instant("imported.forecasts.page.title"));
  }

  public isLoading():boolean{
    return this._isLoading;
  }

  setColumnVisibility(){
    if (!this.hasEspModifyPermission) {
      this.gridColumnApi.setColumnVisible("multiSelect", false);
      this.gridColumnApi.setColumnVisible("actions", false);
    }
  }

  disableRows(params: any) {
    if (params && params.data) {
      return params.data.importStatus.toLowerCase() !== "processed";
    }
    else return false;
  }

  get selectedForecasts() {
    if (this.gridApi !== null) {
      return this.gridApi.getSelectedNodes().map(item => item.data);
    }
    return null;
  }

  get selectedForecastsCount() {
    if (this.gridApi !== null) {
      const selectedNodes = this.gridApi.getSelectedNodes();
      return selectedNodes && selectedNodes !== null && selectedNodes.length > 0 ? selectedNodes.length : 0;
    }
    return 0;
  }

  get hasSelectedImportedForecasts() {
    return this.selectedForecastsCount > 0;
  }

  get hasEspModifyPermission() {
    return this.espPermission === EspPermissions.MODIFY;
  }


  isFinalStatus(importStatus: String) : boolean {
    return (importStatus === ImportedForecastStatusEnum.FAILED
      || importStatus === ImportedForecastStatusEnum.PROCESSED );
  }

  async showImportForecastsDlg() {
    try {
      const modalRef = this.modalService.open(ImportedForecastsDialogComponent, {
        centered: true,
        windowClass: "b-info wfm-modal",
        container: "div.manage-forecasts-content",
        backdrop: "static",
        keyboard: false,
        ariaLabelledBy: "dialogTitle"
      }).result.then( ( result ) => {
        this.importForecastSuccessHandler();
      }, ( reason ) => { } );

    }catch(e){
      console.log(e)
    }

  }

  getImportForecastsList(params: IGetRowsParams) {
    this.currentGetRowParam = params;
    this.startLoadingGrid();
    // console.log("Getting datasource rows, start: " + params.startRow + ", end: " + params.endRow);
    let blockSize = params.endRow - params.startRow;
    let columnId = "FORECAST_NAME";
    let sortOrder = "ASC";
    if (params.sortModel.length > 0) {
      sortOrder = params.sortModel[0].sort.toUpperCase();
      columnId = ColumnId[params.sortModel[0].colId];
    }
    let payload = {
      offset: params.startRow,
      limit: blockSize,
      "sort-by": columnId,
      "sort-order": sortOrder,
      "import-forecast-name-filter": this.filterText
    };
    this.store.dispatch(new GetImportForecastsList(payload));
  }


  filterRows(text) {
    this.filterText = text;
    // Clear any prior announcement immediately when filter is cleared; for
    // non-empty text the receive handler will set the new announcement.
    if (!text) {
      this.searchAnnouncement = "";
    }
    this.currentGetRowParam.startRow = 0;
    let sortModel = this.currentGetRowParam.sortModel;
    if(sortModel.length == 0)
       sortModel = this.DEFAULT_SORT_MODEL;
    this.gridColumnApi.applyColumnState({state:sortModel});
    this.gridApi.ensureIndexVisible(0, "top");
    this.gridApi.setDatasource(this.datasource);
  }

  /**
   * Update the screen-reader announcement for the current filterText using the
   * backend total row count (the infinite row model does not know the real total
   * until the server responds). Empty string when no active search; "No results
   * found" or "{{count}} results found" otherwise. Read by JAWS via the polite
   * aria-live region inside <input-text>.
   */
  private updateSearchAnnouncement(totalCount: number) {
    if (!this.filterText) {
      this.searchAnnouncement = "";
      return;
    }
    this.searchAnnouncement = totalCount === 0
      ? this.translate.instant("search.no.results.msg")
      : this.translate.instant("search.results.count", { count: totalCount });
  }

  // a11y: when focus lands on the select column gridcell, forward focus to
  // the native checkbox so screen readers announce role/state immediately.
  onCellFocused(event: any) {
    if (!event || event.rowIndex == null || event.column?.getColId?.() !== "select") return;
    setTimeout(() => {
      const rowSelector = `.ag-row[row-index="${event.rowIndex}"]`;
      const checkbox = this.document.querySelector<HTMLInputElement>(
        `${rowSelector} .ag-cell[col-id="select"] input[type="checkbox"]`
      );
      if (checkbox && this.document.activeElement !== checkbox) {
        // preventScroll: the cell is already visible (it just received focus);
        // let AG Grid own any grid-viewport scrolling so the outer page does
        // not jump when focus forwards to the row checkbox.
        checkbox.focus({ preventScroll: true });
      }
    });
  }

  // a11y (ESP-18522): keyboard parity with mouse — pressing Enter on ANY data
  // cell opens the Import Forecast Log, the same row-level action as a click.
  // Arrow keys move between cells (AG Grid native); Tab visits the interactive
  // controls only.
  onCellKeyDown(event: any) {
    const kbEvent: KeyboardEvent | undefined = event?.event;
    if (!kbEvent) return;
    if (kbEvent.key === "Enter") {
      this.performCellClick(event);
      return;
    }
    if (kbEvent.key === "Tab") {
      this.moveTabFocusToNextControl(kbEvent);
    }
  }

  // a11y (ESP-18522): drive Tab focus explicitly between the interactive row
  // controls so the Tab order matches the accessibility review exactly:
  //   sortable headers → row-select cell → Forecast Name → optional row actions
  //   → Delete → next row. Relying on AG Grid's native Tab is unreliable — its tab guards
  //   re-focus the originating cell, so Tab appears "stuck" on the checkbox —
  //   hence we move focus ourselves. Shift+Tab walks the same list in reverse.
  //   At the first control, Shift+Tab explicitly returns to the last sortable
  //   Actions header; the browser would otherwise land on AG Grid's rowgroup
  //   container.
  private moveTabFocusToNextControl(kbEvent: KeyboardEvent) {
    const controls = this.getRowInteractiveControls();
    const active = this.document.activeElement as HTMLElement | null;
    if (!active) return;
    // onCellFocused intentionally forwards a select-cell focus event to its
    // native checkbox so a screen reader announces the checkbox state. Treat
    // that checkbox as its owning cell for our managed sequence; otherwise Tab
    // and Shift+Tab see index=-1 and AG Grid exits or lands on a tab guard.
    const activeTarget = active.matches('.ag-cell[col-id="select"] input[type="checkbox"]')
      ? active.closest<HTMLElement>('.ag-cell[col-id="select"]')
      : active;
    const index = activeTarget ? controls.indexOf(activeTarget) : -1;
    if (index === -1) return;
    const nextIndex = kbEvent.shiftKey ? index - 1 : index + 1;
    if (nextIndex < 0) {
      if (kbEvent.shiftKey && this.focusLastHeaderTarget()) {
        kbEvent.preventDefault();
      }
      return;
    }
    if (nextIndex >= controls.length) return;
    kbEvent.preventDefault();
    const next = controls[nextIndex];
    // Keep AG Grid's internal focused cell in sync with our manual focus move,
    // otherwise the previously focused cell keeps its .ag-cell-focus outline
    // (e.g. the first row checkbox stays "focused" after tabbing away).
    this.syncFocusedCell(next);
    // preventScroll: syncFocusedCell() already scrolls the next row into view
    // within the grid's own viewport. The browser's default focus scroll would
    // additionally walk up every scrollable ancestor and shift the whole page,
    // causing the reported unintended page position change (ESP-21749).
    next.focus({ preventScroll: true });
  }

  /**
    * Continue forward Tab traversal from the Actions header into the first
    * rendered interactive body target. Import Forecasts keeps selection focus
    * on the gridcell (the native checkbox is deliberately tabindex=-1).
   */
  public focusFirstGridBodyControl(): boolean {
    const first = this.getRowInteractiveControls()[0];
    if (!first) return false;
    this.syncFocusedCell(first);
    first.focus({ preventScroll: true });
    return true;
  }

  /** Reverse counterpart of focusFirstGridBodyControl(). */
  private focusLastHeaderTarget(): boolean {
    const hostEl = this.elementRef.nativeElement as HTMLElement;
    const headers = Array.from(
      hostEl.querySelectorAll<HTMLElement>(
        ".ag-header-cell:has(button.customHeaderLabel), " +
        ".ag-header-cell.esp-static-header-tab-stop"
      )
    ).filter((header) => header.offsetParent !== null);
    const last = headers[headers.length - 1];
    if (!last) return false;

    // The destination is a header, so clear AG Grid's body-focused-cell model
    // before moving DOM focus; otherwise the row-select cell keeps a stale
    // second focus indicator while Actions is focused.
    this.gridApi?.clearFocusedCell?.();
    last.focus({ preventScroll: true });
    return true;
  }

  // Move AG Grid's focused-cell highlight onto the cell that owns the control we
  // just focused, so the stale outline on the previous cell is cleared.
  private syncFocusedCell(control: HTMLElement) {
    if (!this.gridApi) return;
    const cell = control.closest<HTMLElement>(".ag-cell");
    const row = control.closest<HTMLElement>(".ag-row");
    const colId = cell?.getAttribute("col-id");
    const rowIndex = row?.getAttribute("row-index");
    if (colId == null || rowIndex == null) return;
    this.gridApi.setFocusedCell(parseInt(rowIndex, 10), colId);
  }

  // Clear AG Grid's focused-cell highlight when focus leaves the grid entirely
  // (e.g. Tab out, row delete, row deselect). Without this the stale
  // .ag-cell-focus outline lingers on whichever cell was last focused even
  // after focus has moved outside the grid — the reported "residual border".
  onGridFocusOut(event: FocusEvent) {
    if (!this.gridApi) return;
    const relatedTarget = event.relatedTarget as Node | null;
    const gridRoot = (event.currentTarget as HTMLElement);
    // If focus moved to another element WITHIN the grid, keep the highlight.
    if (relatedTarget && gridRoot.contains(relatedTarget)) return;
    this.gridApi.clearFocusedCell();
  }

  // Interactive targets in the grid body, in visual row/column order. The
  // select CELL is the target for an enabled row because this table deliberately
  // redirects its tabindex=-1 checkbox back to the cell. Other genuine controls
  // are discovered rather than hard-coded, so future optional row actions are
  // not skipped. Disabled/hidden targets and rows without an actionable
  // checkbox are omitted.
  private getRowInteractiveControls(): HTMLElement[] {
    const rows = Array.from(
      this.document.querySelectorAll<HTMLElement>(".ag-center-cols-container .ag-row")
    ).sort(
      (a, b) =>
        parseInt(a.getAttribute("row-index") ?? "0", 10) -
        parseInt(b.getAttribute("row-index") ?? "0", 10)
    );
    const controls: HTMLElement[] = [];
    rows.forEach((row) => {
      const rowControls: HTMLElement[] = [];
      const selectCell = row.querySelector<HTMLElement>('.ag-cell[col-id="select"]');
      const checkbox = selectCell?.querySelector<HTMLInputElement>('input[type="checkbox"]');
      if (selectCell && checkbox &&
          !selectCell.classList.contains("checkbox-disabled") &&
          !selectCell.classList.contains("checkbox-hidden") &&
          !checkbox.disabled &&
          checkbox.getAttribute("aria-disabled") !== "true" &&
          selectCell.offsetParent !== null) {
        rowControls.push(selectCell);
      }

      rowControls.push(...Array.from(
        row.querySelectorAll<HTMLElement>(
          '.ag-cell:not([col-id="select"]) button, ' +
          '.ag-cell:not([col-id="select"]) a[href], ' +
          '.ag-cell:not([col-id="select"]) input, ' +
          '.ag-cell:not([col-id="select"]) select, ' +
          '.ag-cell:not([col-id="select"]) textarea, ' +
          '.ag-cell:not([col-id="select"]) [role="button"]'
        )
      ));

      rowControls.forEach((el) => {
        if (!el.hasAttribute("disabled") &&
            el.getAttribute("aria-disabled") !== "true" &&
            el.offsetParent !== null &&
            !controls.includes(el)) {
          controls.push(el);
        }
      });
    });
    return controls;
  }

  performCellClick(event) {
    if (ColumnId[event.colDef.colId] && event.data && event.data.oid) {

      const importedForecastOid = event.data.oid;
      const importedForecastName = event.data.forecastName;

      try {
        const modalRef = this.modalService.open(ImportedForecastsViewLogComponent, {
          centered: true,
          windowClass: "b-info wfm-modal",
          container: "div.manage-forecasts-content",
          backdrop: "static",
          keyboard: false
        });
        modalRef.componentInstance.importedForecastOid = importedForecastOid;
        modalRef.componentInstance.importedForecastName = importedForecastName;

        modalRef.result.then(
          (result) => {}, (reason) => {}
        );

      }catch(e){
        console.log(e)
      }

    }

  }

  importForecastSuccessHandler() {
    const successMsg = this.translate.instant("import.forecast.dialog.file.upload.success");
    this.messageService.add({ severity: "success", detail: successMsg });
    this.searchBoxEl.clear();
    this.filterText = '';

    const currSortState = this.gridColumnApi.getColumnState().find(col => col.sort !== null);
    if (currSortState && currSortState.colId === "modifiedTime" && currSortState.sort === "desc") {
      this.startLoadingGrid();
      const startRow = this.currentGetRowParam.startRow;
      const blockSize = this.currentGetRowParam.endRow - startRow;
      let payload = {
        offset: startRow,
        limit: blockSize,
        "sort-by": ColumnId.modifiedTime,
        "sort-order": "DESC",
        "import-forecast-name-filter": this.filterText
      };
      this.store.dispatch(new GetImportForecastsList(payload));
      
    } else {
      const colIdArr = this.gridColumnApi.getColumns().map(col => col.colId);
      EspTableHeaderComponent.clearSortOrder();
      let sortModel = EspTableHeaderComponent.getSingleColumnSortModel("modifiedTime", "desc", colIdArr);
      this.gridColumnApi.applyColumnState({ state: sortModel });
    }
    this.gridApi.ensureIndexVisible(0, "top");

  }

  setColumnDefsSort(colId: ColumnId, sortOrder: String) {
    if (!colId || !sortOrder) {
      // default is forecast name ascending
      this.columnDefs[1]["sort"] = "asc";
    } else {
      switch (colId) {
        case ColumnId.modifiedTime:
          this.columnDefs[3]["sort"] = sortOrder;
          break;
        default:
          // plan forecast ascending is default
          this.columnDefs[1]["sort"] = "asc";
      }
    }
  }

  // a11y: Use a dynamic, localized action+identifier label so screen readers
  // announce which row this native checkbox controls (e.g., "Select John Smith record").
  private applyCheckboxName(checkbox: HTMLInputElement, rowName: string) {
    const selectLabel = this.translate.instant("table.checkbox.select", { name: rowName });
    checkbox.setAttribute("aria-label", selectLabel);
    checkbox.removeAttribute("aria-labelledby");
    checkbox.removeAttribute("aria-describedby");
    checkbox.removeAttribute("title");
    // a11y (ESP-18552): keep the native checkbox OUT of the Tab order
    // (tabindex="-1"). The row-select grid cell is itself the Tab stop, and
    // pressing Space/Enter on the focused cell toggles selection. Promoting the
    // checkbox to tabindex="0" made focus land on the cell AND the checkbox
    // (double Tab stop) and moved focus onto the checkbox itself, which the ARIA
    // grid pattern (interactive child reached via the cell) does not want.
    checkbox.setAttribute("tabindex", "-1");

    const checkboxWrappers = [
      checkbox.closest(".ag-selection-checkbox"),
      checkbox.closest(".ag-wrapper")
    ];

    checkboxWrappers.forEach((wrapper) => {
      if (!(wrapper instanceof HTMLElement)) return;
      wrapper.removeAttribute("aria-label");
      wrapper.removeAttribute("aria-labelledby");
      wrapper.removeAttribute("aria-describedby");
      wrapper.removeAttribute("title");
    });
  }

  applyCheckboxAriaLabels() {
    if (this.checkboxAriaLabelsScheduled) return;
    this.checkboxAriaLabelsScheduled = true;

    setTimeout(() => {
      this.checkboxAriaLabelsScheduled = false;
      const rows = this.document.querySelectorAll('.ag-row');
      rows.forEach((row: Element) => {
        const rowIndex = row.getAttribute('row-index');
        if (rowIndex === null) return;
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(parseInt(rowIndex, 10));
        const forecastName = rowNode?.data?.forecastName;
        if (!forecastName) return;
        const checkbox = row.querySelector(
          '.ag-cell[col-id="select"] input[type="checkbox"], .ag-cell[col-id="0"] input[type="checkbox"], input[type="checkbox"].ag-checkbox-input'
        ) as HTMLInputElement;
        if (checkbox) {
          this.applyCheckboxName(checkbox, forecastName);
        }
      });
    }, 0);
  }

  startLoadingGrid(){
    this.gridApi.showLoadingOverlay();
    this._isLoading = true;
  }

  endLoadingGrid(){
    this.gridApi.hideOverlay();
    this._isLoading = false;
  }



  setDefaultSorting(param:any){
    EspTableHeaderComponent.setSortOrder("forecastName", "asc");
  }

  initHandlers() {
    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.ImportForecastsListReceived))
        .subscribe(this.importForecastsListReceiveHandler.bind(this))
    );
    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.ImportForecastsListRetrieveFailed))
        .subscribe(this.importForecastsListRetrieveFailHandler.bind(this))
    );
    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.SortingCleared))
        .subscribe(this.setDefaultSorting.bind(this))
    );

    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.DeleteForecastsSuccess))
        .subscribe(this.deleteForecastsSuccessHandler.bind(this))
    );

    this.addToSubscriptionList(
      this.action$.pipe(ofType(AppActionTypes.DeleteForecastsFailed))
        .subscribe(this.deleteForecastsFailureHandler.bind(this))
    );
  }

  protected addToSubscriptionList(newSubscription: Subscription) {
    this.subscriptionList.push(newSubscription);
  }

  private clearSubscriptionList() {
    if (this.subscriptionList.length > 0) {
      this.subscriptionList.forEach(subscriptionItem => subscriptionItem.unsubscribe());
      this.subscriptionList = null;
    }
  }

  private prevData: any = { metadata: [], lastRow: 0 };

  importForecastsListReceiveHandler(action: ImportForecastsListReceived) {
    let data = action.payload;
    if(action.requestPayload && action.requestPayload["import-forecast-name-filter"]!=this.filterText){
      return;
    }
    var lastRow = -1;
    if (data.totalCount <= this.currentGetRowParam.endRow) {
      lastRow = data.totalCount;
    }
    // Checks the data and make sure that the return is an array for the grid to process properly
    let metadata = !data.metadata || data.metadata === null ? [] : data.metadata;
    if (data.offset == 0) {
      //it's the first page
      this.prevData = { metadata, lastRow };
      // Announce search results count to screen readers using the backend total
      // (gridApi.getDisplayedRowCount() is unreliable for the infinite row model).
      this.updateSearchAnnouncement(data.totalCount ?? 0);
    } else {
      //append to previous import forecasts
      this.prevData = { metadata: [...this.prevData.metadata, ...metadata], lastRow };
    }
    this.currentGetRowParam.successCallback(metadata, lastRow);
    this.endLoadingGrid();
    // In case we have no import forecasts, we want to show no row overlay
    if (Array.isArray(metadata) && metadata.length === 0) {
      this.gridApi.showNoRowsOverlay();
    }
  }

  importForecastsListRetrieveFailHandler(action: ImportForecastsListRetrieveFailed) {
    console.log("ERROR retrieving import forecasts list");
    if (this.prevData.metadata.length > 0) {
      let metadata = this.prevData.metadata.slice(0, 100); //100 is the block size
      this.currentGetRowParam.successCallback(metadata, metadata.length);
    } else {
      this.currentGetRowParam.successCallback([], 0);
    }
    this.endLoadingGrid();
    let failMsg = this.translate.instant("imported.forecasts.retrieve.failed");
    this.messageService.add({ severity: "error", detail: failMsg });
  }


  deleteSelectedForecasts() {
    // Close the confirmation popover before dispatching the delete. The Cancel
    // button closes it via the template ref, but Confirm only ran the delete —
    // so activating Confirm with the keyboard (Space commits on keyup, after
    // the button's click) left the dialog on screen. Closing here makes the
    // dialog dismiss deterministically for mouse, Enter and Space alike.
    this.forecastDeletePopover?.close();
    this.deleteForecasts(this.selectedForecasts);
  }

  focusForecastDeleteDialog() {
    // a11y (WCAG 2.4.3 Focus Order, ARIA dialog pattern): move focus to the
    // first interactive control (Cancel) when the delete popover opens.
    setTimeout(() => {
      // a11y: ng-bootstrap gives the popover wrapper role="tooltip", whose text
      // content (the confirmation prompt) is exposed as its accessible name.
      // Combined with the nested role="dialog" labelled by that same prompt,
      // JAWS announced the message twice. Strip the redundant tooltip semantics
      // so only the inner dialog announces the prompt once. Only neutralize when
      // ng-bootstrap actually applied role="tooltip", so future markup changes
      // are not silently clobbered.
      const popoverWindow = this.document.querySelector<HTMLElement>("ngb-popover-window");
      if (popoverWindow?.getAttribute("role") === "tooltip") {
        popoverWindow.setAttribute("role", "presentation");
      }
      const firstBtn = this.document.querySelector<HTMLElement>('ngb-popover-window [role="dialog"] button');
      if (firstBtn) {
        firstBtn.focus();
        return;
      }
      this.document.querySelector<HTMLElement>('ngb-popover-window [role="dialog"]')?.focus();
    });
  }

  // a11y (focus trap): cycle Tab / Shift+Tab between Cancel and Confirm so
  // focus cannot escape the open delete popover.
  onForecastDeleteDialogTab(event: KeyboardEvent): void {
    const dialog = this.document.querySelector<HTMLElement>('ngb-popover-window [role="dialog"]');
    const buttons = Array.from(this.document.querySelectorAll<HTMLElement>('ngb-popover-window [role="dialog"] button'));
    if (!dialog || buttons.length < 2) return;
    const first = buttons[0];
    const last = buttons[buttons.length - 1];
    const active = this.document.activeElement;
    const shift = event.shiftKey;
    if (!shift && active === last) {
      event.preventDefault();
      first.focus();
    } else if (shift && active === first) {
      event.preventDefault();
      last.focus();
    }
  }

  returnFocusToForecastDeleteBtn(): void {
    // a11y: return focus to the Delete button when the popover closes.
    setTimeout(() => {
       this.document.querySelector<HTMLElement>('#btn-delete button')?.focus();
    });
  }

  deleteSingleForecast(forecast: any){
    let forecasts = [forecast];
    this.deleteForecasts(forecasts);
  }

  deleteForecasts(forecasts: any) {
    const forecastIds = forecasts.map((forecast: any) => forecast.oid);
    this.startLoadingGrid();
    this.store.dispatch(new DeleteImportedForecasts(forecastIds));
  }


  deleteForecastsSuccessHandler(action: DeleteForecastsSuccess) {
    if (action.payload) {
      let deletedForecastsResp = action.payload.deletedForecasts;
      let succeeded: Array<string> = deletedForecastsResp.SUCCESS;
      let failed = deletedForecastsResp.FAILED;
      let sortModel = this.currentGetRowParam.sortModel;
      if(sortModel.length == 0)
        sortModel = this.DEFAULT_SORT_MODEL;
      this.gridColumnApi.applyColumnState({state:sortModel});
      // this.gridApi.deselectAll();
      // this.gridApi.refreshInfiniteCache();
      this.gridApi.ensureIndexVisible(0, "top");
      this.gridApi.setDatasource(this.datasource);
      if ((failed == null || failed.length == 0) && succeeded.length > 0) {
        let deleted = (succeeded.length == 1) ? "single" : "multiple";
        let successMsg = this.translate.instant("imported.forecasts.delete.success." + deleted);
        this.messageService.add({ severity: "success", detail: successMsg });
      }
      else if (failed.length > 0) {
        let failMsg = this.translate.instant("imported.forecasts.delete.failed");
        this.messageService.add({ severity: "error", detail: failMsg });
      }
    }

    this.endLoadingGrid();

  }

  deleteForecastsFailureHandler(action: DeleteForecastsFailed){
    const failMsg = this.translate.instant("imported.forecasts.retrieve.failed");
    this.messageService.add({ severity: "error", detail: failMsg });
    this.endLoadingGrid();
  }

  public ngOnDestroy() {
    this.selectionCheckboxFocusCleanup?.();
    this.selectionCheckboxFocusCleanup = null;
    this.scrollRegionSyncCleanup?.();
    this.scrollRegionSyncCleanup = null;
    this.clearSubscriptionList();
  }

  checkBoxCellClass = (p:any) => {
    if (p.data && p.data.importStatus && this.hasEspModifyPermission) {
      return (this.isFinalStatus(p.data.importStatus)) ? '' :  'checkbox-disabled';
    } else {
      return 'checkbox-hidden';
    }
  }

  icons = {
    checkboxDisabled: `<svg class="icon"><use xlink:href="#icon-rect-disabled" /></svg>`,
    checkboxCheckedReadOnly: `<svg class="icon"><use xlink:href="#icon-rect-readonly" /></svg>`,
    sortAscending: `<svg class="icon"><use xlink:href="#icon-sort-ascending" /></svg>`,
    sortDescending: '<svg class="icon"><use xlink:href="#icon-sort-descending" /></svg>'
  };
  columnDefs:any = [
    {
      // Row selection column. Header text is visually hidden via the
      // existing .screenreader-only class but exposed to screen readers,
      // so the column has a programmatic accessible name (a11y).
      headerName: this.translate.instant("table.header.select"),
      colId: "select",
      field: null,
      sortable: false,
      headerClass: "screenreader-only",
      checkboxSelection: () => (this.hasEspModifyPermission),
      cellClass: this.checkBoxCellClass.bind(this),
      headerCheckboxSelection: false,
      suppressSizeToFit: true,
      width: 50,
      headerTooltip: " "
    },
    {
      headerName: this.translate.instant("imported.forecasts.header.forecastName"),
      field: "forecastName",
      colId: "forecastName",
      cellRenderer: "TooltipField",
      // a11y (ESP-18464 / Dragon): expose the forecast name as a voice-clickable
      // button when the row can be opened (has an oid).
      cellRendererParams: {
        rowOpenAction: true,
        canOpen: (data: any) => !!data && !!data.oid
      },
      minWidth:150
    },
    {
      headerName: this.translate.instant("imported.forecasts.header.dateRange"),
      colId: "dateRange",
      cellRenderer: "DateRangeField",
      cellRendererParams: () => (environment.locales.find(l => l.locale === this.locale)),
      minWidth:150
    },
    {
      headerName: this.translate.instant("imported.forecasts.header.modifiedTime"),
      field: "modifiedTime",
      colId: "modifiedTime",
      cellRenderer: "ModifiedDateField",
      cellRendererParams: () => (environment.locales.find(l => l.locale === this.locale)),
      minWidth:150
    },
    {
      headerName: this.translate.instant("imported.forecasts.header.createdBy"),
      field: "createdBy",
      colId: "createdBy",
      cellRenderer: "TooltipField",
      minWidth:150
    },
    {
      headerName: this.translate.instant("imported.forecasts.header.importStatus"),
      field: "importStatus",
      colId: "importStatus",
      cellRenderer: "TooltipField",
      minWidth:150
    },
    {
      headerName: this.translate.instant("imported.forecasts.header.actions"),
      colId: "actions",
      sortable: false,
      headerClass: "text-center only-action",
      suppressSizeToFit: true,
      width: 100,
      suppressKeyboardEvent: combineGridKeyboardSuppressors(suppressGridTabToInteractiveControls, suppressHomeEndKeyboardEvent, tabSuppressKeyboardEventForFocusableChildren),
      cellRendererSelector: (p:any)=>(!this.hasEspModifyPermission 
        || p.data === undefined || p.data.importStatus === undefined || !this.isFinalStatus(p.data.importStatus) )
        ? null :
        {
          component: 'GridItemActionComponent',
          params: {
            callback: this.deleteSingleForecast.bind(this),
            messageDelete: this.translate.instant("imported.forecasts.delete.single"),
            itemNameField: "forecastName"
          }
        }
    }
  ];

}

export enum ColumnId {
  forecastName = "FORECAST_NAME",
  dateRange = "DATE_RANGE",
  modifiedTime = "IMPORT_DATE",
  createdBy = "IMPORTED_BY",
  importStatus = "STATUS",
}
